module.exports = __webpack_public_path__ + "img/1564211449.0cc26bdc.jpg";